import ReactFlow, { Background } from 'reactflow';
import styled from 'styled-components';
import 'reactflow/dist/style.css';

import { Model, ModelDirection } from 'types';
import ContextMenu from './components/ContextMenu';
import useFlow from './hooks/useFlow';
import FlowHeader from './components/FlowHeader/FlowHeader';
import ConnectionLine from './components/edges/ConnectionLine';
import { EDGE_TYPES, NODE_TYPES } from 'constants/flow';
import useRightSideBarFull from 'pages/Editor/hooks/useRightSideBarFull';

const Layout = styled.div<{ $isRightSideBarFull: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;

  ${(props) => {
    if (props.$isRightSideBarFull) {
      return {
        maxWidth: 0,
        overflow: 'hidden',
      };
    }
  }}
`;

const Container = styled.div`
  position: relative;
  flex: 1;
`;

const FlowView = styled.div`
  flex-grow: 1;
  height: 100%;

  .react-flow {
    background-color: ${(props) => props.theme.editor.flowBgColor};
  }
`;

const proOptions = {
  account: 'paid-pro',
  hideAttribution: true,
};

interface FlowProps {
  model: Model;
  modelDirection: ModelDirection;
}

const Flow = ({ model, modelDirection }: FlowProps) => {
  const { isFullAndSelected } = useRightSideBarFull();
  const { contextMenu, closeContextMenu, ...flowHandler } = useFlow({
    model,
    modelDirection,
  });

  return (
    <Layout $isRightSideBarFull={isFullAndSelected}>
      <FlowHeader />
      <Container className="no-dragging">
        {/* <FlowButtons /> */}
        <FlowView>
          <ReactFlow
            snapToGrid
            connectionLineComponent={ConnectionLine}
            deleteKeyCode={['Delete', 'Backspace']}
            proOptions={proOptions}
            minZoom={0.1}
            nodeTypes={NODE_TYPES}
            edgeTypes={EDGE_TYPES}
            {...flowHandler}
          >
            <Background />
          </ReactFlow>
        </FlowView>
        {contextMenu && <ContextMenu {...contextMenu} onClose={closeContextMenu} />}
      </Container>
    </Layout>
  );
};

export default Flow;
